import {COMPLAINT_CHANGE_COMPLAINT_TYPE} from '../types/Complaint';
import {GET_COMPONENTS_SUCCESS} from '../types/Components';
import { INITIAL_STATE} from './state/ComplaintPositionsComponents';
import * as componentSelector from "../selectors/ComponentSelector";

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        // case COMPLAINT_CHANGE_COMPLAINT_TYPE:
        //     switch (action.payload.complaintType.name) {
        //         case "Warranty":
        //             return {
        //                 ...INITIAL_STATE,
        //                 displayAmount: true,
        //                 displayArticleIsCompleted:true,
        //                 displayArticleHasDisassemblySigns:true,
        //                 displayArticlePurchaseAddress:true,
        //                 displayArticleSerialNumber:true,
        //                 displayFaultDescription: true,
        //                 displayFiles: true,
        //                 displayMountingAddress:true,
        //                 displayNotes: true,
        //                 displayProduct: true,
        //                 displayPurchaseDate:true,
        //                 displayPurchaseProve:true,
        //                 displayQuantityCorrectionsProposal: true,
        //             };
        //             case "SalesWarranty":
        //             return {
        //                 ...INITIAL_STATE,
        //                 displayAmount: true,
        //                 displayArticleIsCompleted:true,
        //                 displayArticleHasDisassemblySigns:true,
        //                 displayArticlePurchaseAddress:true,
        //                 displayArticleSerialNumber:true,
        //                 displayFaultDescription: true,
        //                 displayFiles: true,
        //                 displayMountingAddress:true,
        //                 displayProduct: true,
        //                 displayPurchaseDate:true,
        //                 displayPurchaseProve:true,
        //                 displayQuantityCorrectionsProposal: true,
        //             };
        //         case "DeliveryMismatch":
        //             return {
        //                 ...INITIAL_STATE,
        //                 displayInvoiceQuantity: true,
        //                 displayProduct: true,
        //                 displayQuantityCorrectionsProposal: true,
        //                 displaySalesDocumentNumber: true,
        //                 displaySalesDocumentPosition: true,
        //                 displayShippedQuantity: true
        //             };
        //         case "PayedRepair":
        //             return {
        //                 ...INITIAL_STATE,
        //                 displayAmount: true,
        //                 displayArticleSerialNumber: true,
        //                 displayFaultDate: true,
        //                 displayFaultDescription: true,
        //                 displayFaultDiscoveryCircumstances: true,
        //                 displayProduct: true,
        //                 displayShipmentDescription: true,
        //                 displayTermOfUse: true,
        //             };
        //         case "PostWarrantyLaserDeviceCalibration":
        //             return {
        //                 ...INITIAL_STATE,
        //                 displayProduct: true,
        //                 displayAmount: true,
        //                 displayFaultDescription: true,
        //                 displayArticleSerialNumber: true,
        //                 displayShipmentDescription: true,
        //                 displayTermOfUse: true,
        //             };
        //         case "TransportDamage":
        //             return {
        //                 ...INITIAL_STATE,
        //                 displayAmount: true,
        //                 displayCourier: true,
        //                 displayDateOfReceiptOfGoods: true,
        //                 displayFaultDescription: true,
        //                 displayFiles: true,
        //                 displayProduct: true,
        //                 displaySalesDocumentNumber: true,
        //                 displaySalesDocumentPosition: true,
        //             };
        //         case "UnderWarrantyLaserDeviceCalibration":
        //             return {
        //                 ...INITIAL_STATE,
        //                 displayAmount: true,
        //                 displayArticleSerialNumber: true,
        //                 displayFaultDiscoveryCircumstances: true,
        //                 displayFiles: true,
        //                 displayProduct: true,
        //                 displaySalesDocumentNumber: true,
        //                 displayShipmentDescription: true,
        //             };
        //     } 
        //     break;
        case GET_COMPONENTS_SUCCESS:
            return { 
                ...state, 
                complaintPositionComponents: action.payload,
            };
    }
    return state;
}

export const getComplaintPositionComponentsForCustomer = (components, compliantTypeId, customerTypeId, area) => componentSelector.getComplaintPositionComponentsForCustomer(components, compliantTypeId, customerTypeId, area);


// WEBPACK FOOTER //
// ./src/reducers/ComplaintPositionsComponents.js